import { render, staticRenderFns } from "./FormRequired.vue?vue&type=template&id=97d2c638&"
import script from "./FormRequired.vue?vue&type=script&lang=js&"
export * from "./FormRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports